import { FC } from 'react';

export interface ThreeDPointProps {
  position: [number, number, number];
  size?: number;
  color?: string;
  opacity?: number;
  alwaysOnTop?: boolean;
}
/**
 * default values
 * size = 0.01
 * color = 'red'
 * opacity = 0.5
 */
export const ThreeDPoint: FC<ThreeDPointProps> = ({
  position,
  size = 0.01,
  color = 'red',
  opacity = 0.5,
  alwaysOnTop = false,
}) => {
  // render order is used to ensure the point is rendered on top of other objects
  // depth test is used to ensure the point is rendered on top of other objects
  // depth write is used to ensure the point is rendered on top of other objects
  return (
    <mesh position={position} renderOrder={1000}>
      <sphereGeometry args={[size, 32, 32]} />
      <meshBasicMaterial
        color={color}
        transparent
        opacity={opacity}
        depthTest={!alwaysOnTop}
        depthWrite={!alwaysOnTop}
      />
    </mesh>
  );
};
